import React from "react";
import Navbar from "./NavBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const HeaderTop = () => {
  return (
    <div className="header-top-bar">
      <div className="email-btn-top">
        <FontAwesomeIcon icon={faEnvelope} /> info@icaresolutions.ca
      </div>
    </div>
  );
};

const Header = ({
  loggedIn,
  setLogin,
  authChecking,
  setSelectedSection,
  toggleSidebar,
  setSelectedCareService,
}) => {
  return (
    <header className="header-wrapper">
      {/* <HeaderTop /> */}
      <Navbar
        loggedIn={loggedIn}
        setLogin={setLogin}
        authChecking={authChecking}
        toggleSidebar={toggleSidebar}
        setSelectedSection={setSelectedSection}
        setSelectedCareService={setSelectedCareService}
      />
    </header>
  );
};

export default Header;
